import { Map } from 'immutable';

import {
    SET_POI_VIEWPORT,
    SET_POIS,
    CONCAT_POIS,
    RESET_POIS,
    RESET_BOUNDARIES,
    SET_BOUNDARIES,
    CONCAT_BOUNDARIES,
} from './actions';

const POI = (state = Map({ topLeft: null, bottomRight: null, organizationIds: null, pois: [], boundaries: [] }), action) => {
    switch (action.type) {
      case SET_POI_VIEWPORT:
        return state.set('topLeft', action.payload.topLeft).set('bottomRight', action.payload.bottomRight);
      case SET_POIS:
        return state.set('pois', action.payload.pois);
      case CONCAT_POIS:
        const curPOIs = state.get('pois');
        return state.set('pois', [...curPOIs , ...action.payload.pois]);
      case RESET_POIS:
        return state.set('pois', []);
      case RESET_BOUNDARIES:
        return state.set('boundaries', []);
      case SET_BOUNDARIES:
        return state.set('boundaries', action.payload.boundaries);
      case CONCAT_BOUNDARIES:
        const curBoundaries = state.get('boundaries');
        return state.set('boundaries', [...curBoundaries, ...action.payload.boundaries]);
      default:
        return state;
    }
};

export default POI;


// WEBPACK FOOTER //
// ./src/POI/reducers.js